import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class AutomaticInvoicingStatusError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AutomaticInvoicingStatusError', ...args);
    }
}
export default AutomaticInvoicingStatusError;
